import { InjectionToken, Type } from '@angular/core';

/** A tab an app adds to Account Settings, after the built-in ones (e.g. Dib's Background Tasks). */
export interface AccountSettingsTab {
  /** The `?tab=` value. */
  routingParam: string;
  /** Transloco key of the tab title. */
  titleKey: string;
  component: Type<unknown>;
}

export const ACCOUNT_SETTINGS_TABS = new InjectionToken<AccountSettingsTab[]>(
  'ACCOUNT_SETTINGS_TABS',
  { factory: () => [] }
);
